import { constants } from '../constants'

// Fields the Messages tab always enforces, regardless of which refetch path runs
// (initial load, refresh button, pagination, sort, archive, "By Surgeons", etc.):
//   - customerIds : the currently open customer — never cleared, so an admin in
//                   Customer -> Messages only ever sees that customer's messages.
//   - titles      : the Messages tab only ever lists Surgeon Messages.
// Spread this LAST over any locally-built filter so it always wins.
export function messageScope({ customer, decoded } = {}) {
  const customerId =
    customer && customer._id ? customer._id : decoded && decoded.customer
  return {
    customerIds: [customerId],
    titles: [constants.ACTION_CASE_TITLE.SURGEON_MESSAGE],
  }
}

// Inverse guard for the Cases page. The redux filter slices are shared with
// the Messages tab, so the messageScope() fields can leak into any Cases
// refetch path (mount, pagination, sort, filter modal). Cases has no
// "Surgeon Message" type option, so its presence means the scope leaked in —
// drop it, along with the clinic customerIds it was bundled with. Returns a
// new object; never mutates the shared slice.
export function stripMessageScope(filter) {
  const copy = { ...(filter || {}) }
  if (
    Array.isArray(copy.titles) &&
    copy.titles.includes(constants.ACTION_CASE_TITLE.SURGEON_MESSAGE)
  ) {
    delete copy.titles
    delete copy.customerIds
  }
  return copy
}
